<app-navbar title="Dodawanie segmentu">
	<button
		mat-raised-button
		color="primary"
		class="save-button"
		[disabled]="nameControl.invalid || isSaving()"
		(click)="saveSegment()"
	>
		@if (isSaving()) {
			<mat-spinner diameter="18"></mat-spinner>
		} @else {
			<span>Zapisz</span>
		}
	</button>
</app-navbar>

<section class="p-3">
	<div class="segment-form">
		<mat-form-field appearance="outline" class="w-100">
			<mat-label>Nazwa segmentu</mat-label>
			<input matInput [formControl]="nameControl" />
		</mat-form-field>
	</div>

	<mat-card class="terms-card mt-3" [formGroup]="filtersForm">
		<mat-card-content>
			<div class="terms-filters">
				<mat-form-field appearance="outline">
					<mat-label>Wyszukaj</mat-label>
					<input matInput formControlName="search" />
				</mat-form-field>

				<mat-form-field appearance="outline">
					<mat-label>Zakwaterowanie od</mat-label>
					<input matInput [matDatepicker]="accommodationAfterPicker" formControlName="accommodationAfter" />
					<mat-datepicker-toggle matSuffix [for]="accommodationAfterPicker"></mat-datepicker-toggle>
					<mat-datepicker #accommodationAfterPicker></mat-datepicker>
				</mat-form-field>

				<mat-form-field appearance="outline">
					<mat-label>Zakwaterowanie do</mat-label>
					<input matInput [matDatepicker]="accommodationBeforePicker" formControlName="accommodationBefore" />
					<mat-datepicker-toggle matSuffix [for]="accommodationBeforePicker"></mat-datepicker-toggle>
					<mat-datepicker #accommodationBeforePicker></mat-datepicker>
				</mat-form-field>
			</div>

			<div class="mt-2">
				<button mat-raised-button color="primary" [disabled]="filtersForm.invalid" (click)="searchTerms()">
					Wyszukaj terminy
				</button>
			</div>

			<div class="table-wrapper mt-3">
				<table
					mat-table
					matSort
					(matSortChange)="onSortChange($event)"
					[dataSource]="transportTerms()"
					class="w-100"
				>
					<ng-container matColumnDef="select">
						<th mat-header-cell *matHeaderCellDef>
							<mat-checkbox
								[checked]="isAllSelected()"
								(change)="toggleAllSelection($event.checked)"
							></mat-checkbox>
						</th>
						<td mat-cell *matCellDef="let element">
							<mat-checkbox
								[checked]="isTermSelected(element.id)"
								(change)="toggleTermSelection(element, $event.checked)"
							></mat-checkbox>
						</td>
					</ng-container>

					<ng-container matColumnDef="id">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
						<td mat-cell *matCellDef="let element">{{ element.id }}</td>
					</ng-container>

					<ng-container matColumnDef="name">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Nazwa</th>
						<td mat-cell *matCellDef="let element">{{ element.name }}</td>
					</ng-container>

					<ng-container matColumnDef="accommodationLower">
						<th mat-header-cell *matHeaderCellDef mat-sort-header="accommodationLower">
							Zakwaterowanie od
						</th>
						<td mat-cell *matCellDef="let element">
							{{ element.accommodation?.lower | date: 'dd.MM.yyyy' }}
						</td>
					</ng-container>

					<ng-container matColumnDef="accommodationUpper">
						<th mat-header-cell *matHeaderCellDef mat-sort-header="accommodationUpper">
							Zakwaterowanie do
						</th>
						<td mat-cell *matCellDef="let element">
							{{ element.accommodation?.upper | date: 'dd.MM.yyyy' }}
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell text-center py-3" [attr.colspan]="displayedColumns.length">Brak wyników</td>
					</tr>
				</table>
			</div>
		</mat-card-content>
	</mat-card>
</section>
